import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
export default (function (icon, organisationId, assetId, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_UPDATE_ICON, {
        organisationId: organisationId,
        assetId: assetId
    });
    var request = new Request({
        method: Methods.PUT,
        url: url,
        data: icon,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
